module.exports = __webpack_public_path__ + "static/media/logo-kyth@2x.0a673829.png";